import {getRequest, sendRequest} from './api';

/**
 * Получение списка Мои организации.
 * @param {string} organisation_id - Идентификатор организации.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchGetRight(organisation_id) {
  return getRequest(`/role/getright?organisation_id=${organisation_id}`);
}

/**
 * Получение типа роли для организации.
 * @param {string} organisation_id - Идентификатор организации.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchGetGetType(organisation_id) {
  return getRequest(`/role/gettype?organisation_id=${organisation_id}`);
}

/**
 * Получение списка ролей организации.
 * @param {string} user_id - Идентификатор пользователя.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchRoles(organisation_id) {
  return getRequest(`/role`, {organisation_id});
}
/**
 * Обновление полей организации.
 * @param {object} data - Данные организации id обязательный!!!.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function sendCreateRole(data) {
  return sendRequest('/role', 'POST', data);
}
/**
 * Обновление роли организации.
 * @param {object} data - Данные организации id обязательный!!!.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function sendUpdateRole(data) {
  return sendRequest('/role', 'PUT', data);
}
/**
 * Обновление роли организации статуса.
 * @param {object} data - Данные организации id обязательный!!!.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function sendUpdateRoleStatus(data) {
  return sendRequest('/role/status', 'PUT', data);
}
/**
 * Удаление роли организации.
 * @param {object} data - Данные организации id обязательный!!!.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function deleteRole(data) {
  return sendRequest('/role', 'DELETE', data);
}
// /**
//  * Удаление организации id обязательный.
//  * @param {string} id - id организации обязательный.
//  * @returns {Promise<any>} - Ответ от сервера .
//  */
// export async function deleteOrganisation(id) {
//   return sendRequest('/organisation', 'DELETE', {id});

// }

/**
 * Получение списка сотрудников организации.
 * @param {string} user_id - Идентификатор пользователя.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchEmployees(organisation_id) {
  return getRequest(`/role`, {organisation_id});
}

/**
 *
 * @param {*} data В теле запроса; user_id1, user_id2, organisation_id
 * @returns
 */
export async function crateRelateRole(data) {
  return sendRequest('/user/relate', 'POST', data);
}
// crateRelateRole({
//   organisation_id: '68b6c7c9-0a73ac6e-c3f0-400d-8d2260d40cdb',
//   user_id1: '68b6c724-db6db24f-75ae-4f0a-848e95f15b4d',
//   user_id2: '68f9e3f0-179f995c-8a67-466d-b4ae501b0780',
// });
